var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { width: "95%" }, attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        [
          _c("h1", [
            _vm._v(
              "(" +
                _vm._s(_vm.hotelcode) +
                ") " +
                _vm._s(_vm.hotelname) +
                " Daily Planner"
            ),
          ]),
          _vm._v(" "),
          _c("ies-hotel-quick-links", { attrs: { pageid: _vm.hotelkey } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "Rates are in " +
            _vm._s(_vm.currencycode) +
            " per room/unit per night" +
            _vm._s(_vm.taxSummary)
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _vm.responseDataReady
                ? _c("ies-hotel-planner-table-controls", {
                    attrs: {
                      tableViewOptions: _vm.tableViewOptions,
                      selectedTableViewOptions: _vm.selectedTableViewOptions,
                      hotelKey: _vm.hotelkey,
                    },
                    on: {
                      "update:selectedTableViewOptions": function ($event) {
                        _vm.selectedTableViewOptions = $event
                      },
                      "update:selected-table-view-options": function ($event) {
                        _vm.selectedTableViewOptions = $event
                      },
                      updateNumMonths: _vm.handleUpdateVisibleMonths,
                      updateAvailabilityRowDisplay:
                        _vm.handleUpdateAvailabilityRowDisplay,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.responseDataReady
                ? _c("ies-hotel-planner-month-controls", {
                    attrs: {
                      hotelkey: _vm.hotelkey,
                      rateColumns: _vm.rateColumns,
                      selectedDate: _vm.selectedDate,
                      isPlannerPage: true,
                      resetMonthControls: _vm.resetMonthControls,
                    },
                    on: {
                      "update:selectedDate": function ($event) {
                        _vm.selectedDate = $event
                      },
                      "update:selected-date": function ($event) {
                        _vm.selectedDate = $event
                      },
                      "update:resetMonthControls": _vm.handleMonthControlsReset,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", [_c("strong", [_vm._v("Legend")])]),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "mb-4" },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "d-flex justify-space-between",
                      attrs: { xs12: "" },
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "legend-icon room-available" },
                          [_vm._v(" ")]
                        ),
                        _vm._v(" Available"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "legend-icon room-on-request" },
                          [_vm._v(" ")]
                        ),
                        _vm._v(" On Request"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "legend-icon room-unavailable" },
                          [_vm._v(" ")]
                        ),
                        _vm._v(" Unavailable"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "legend-icon property-closed" },
                          [_vm._v(" ")]
                        ),
                        _vm._v(" Property Closed"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "legend-icon selected" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" Selected for editing"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "legend-icon updated" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" Updated"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "indicative" }, [
                        _c("span", { staticClass: "legend-icon" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" Indicative Rate"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.monthsToShow, function (month) {
                return _vm.responseDataReady && _vm.selectedDate
                  ? _c("ies-hotel-planner-table", {
                      attrs: {
                        hotelkey: _vm.hotelkey,
                        currencycode: _vm.currencycode,
                        dateFrom: month,
                        tableViewOptions: _vm.tableViewOptions,
                        selectedTableViewOptions: _vm.selectedTableViewOptions,
                        isDisabled:
                          _vm.isChannelManaged || _vm.abrigedTableMode,
                        abrigedTableMode: _vm.abrigedTableMode,
                        availabilityCellDisplay: _vm.availabilityCellDisplay,
                      },
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }